import React from 'react'

export default function BulkdealsFAQ() {
  return (
    <><h3>FAQs</h3>
    <div className='today-faqs'>
    <h3>What is a bulk deal?</h3>

<p>Bulk deal in the share market is a deal where the total quantity of shares bought or sold is greater than 0.5% of the share capital of the company. A bulk deal can be transacted either through the normal trading window or through the block trading window.</p>

<h3>Does bulk deal affect share price?</h3>

<p>Yes, bulk deals affect the share prices of the company because these deals happen during the normal trading window provided by the broker and it is a market-driven deal. The deal is visible to everyone trading on the stock exchange.</p>

<h3>How do I find block deals?</h3>

<p>You may get a list of block deals reported to the BSE and NSE at the end of the day by the members. You can check the company name as well as the client for whom the deal was done. This enables you to see who is buying and who is selling stocks. You also get the rate and quantity of the block deal.</p>

<h3>What is the minimum amount for bulk deal?</h3>

<p>0.5%</p>

<p>To qualify as a bulk deal, the transaction needs to account for at least 0.5% of the total shares of the company, irrespective of the value of the trade.</p>

<h3>What time is bulk deals?</h3>

<p>Bulk deals take place within regular trading hours in the stock market i.e. 9:15 am to 3:30 pm</p>

<h3>How can I get bulk deal in NSE?</h3>

<p>Bulk deals may happen via normal trading windows provided by stock brokers during normal trading hours. Bulk deals usually involve Institutitons and occasionaly High Net Worth Individuals (HNIs).</p>

    </div>
    </>
  )
}
